import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import {
    ColDef,
    GetRowIdParams,
    GridReadyEvent,
    LicenseManager,
    ModuleRegistry,
    RowStyleModule,
    TreeDataModule,
} from "ag-grid-enterprise";
import { AgGridReact, AgGridReactProps } from "ag-grid-react";
import React, { useMemo, useRef } from "react";
import { useSeller, useUser } from "../../../hooks/useAccount";
import { PartnersReportData } from "../../../reports/PartnerCommissionsReport";
import { ErrorBoundary } from "../../ErrorBoundary";
import "./PartnerCommissionsTable.css";
import { config } from "../../../config";
import { isAffiliate } from "../../../models/User";

interface PartnerCommissionsTableProps extends AgGridReactProps {
    values: any;
    columnDefs: ColDef[];
}
ModuleRegistry.registerModules([TreeDataModule, RowStyleModule]);
export const PartnerCommissionsTable = ({ values, columnDefs }: PartnerCommissionsTableProps) => {
    const user = useUser();
    const seller = useSeller();
    const gridRef = useRef<AgGridReact>(null);

    // Portal all the column filters into .ag-theme-alpine outside the header section so they don't get
    // clipped by the header
    const popupParent = useMemo<HTMLElement>(() => document.querySelector(".ui-column-layout-fill")!, []);

    if (isAffiliate(user)) {
        columnDefs[4].hide = true; // hide Take Action for affiliate users
    }

    return (
        <div>
            <ErrorBoundary>
                <div className="ag-theme-alpine ui-partner-commission-table" style={{ height: "100vh" }}>
                    <AgGridReact
                        ref={gridRef}
                        suppressContextMenu
                        suppressRowClickSelection
                        treeData
                        theme="legacy"
                        defaultColDef={defaultColDef}
                        rowData={values}
                        columnDefs={columnDefs}
                        context={{ seller }}
                        getRowId={getRowId}
                        popupParent={popupParent}
                        getDataPath={getDataPath}
                        autoGroupColumnDef={autoGroupColumnDef}
                        onGridReady={handleGridReady}
                    />
                </div>
            </ErrorBoundary>
        </div>
    );
};

const autoGroupColumnDef: ColDef = {
    headerName: "",
    maxWidth: 50,
    showRowGroup: true,
    cellRendererParams: {
        suppressCount: true,
        innerRenderer: () => null,
    },
};

const defaultColDef: ColDef = {
    flex: 1,
    resizable: false,
    minWidth: 150,
    sortable: false,
    filter: false,
    menuTabs: [],
    suppressMovable: true,
};

const getRowId = (params: GetRowIdParams) => {
    return params.data?.id;
};

const getDataPath = (data: PartnersReportData) => {
    if (data.parent) {
        return [data.parent, data.id];
    }

    return [data.id];
};

const handleGridReady = (params: GridReadyEvent) => {
    params.api.forEachNode((node) => {
        if (node.group) {
            node.setExpanded(true);
        }
    });
};

if (config.agGrid?.key) {
    LicenseManager.setLicenseKey(config.agGrid.key);
}
